import { AppConfigModel } from "../abstract/app-config.model";

export class VatFrequency extends AppConfigModel {

    static override CLASS_NAME: string = 'VatFrequency';
}
